export default __webpack_public_path__ + "static/medicare-desktop-66ed9c3963ad3a0eae497bafdd5cbaca.png";